import { getMonth, getDay } from 'date-fns'
import { dateUtils } from '@/utils'
import { type SimpleSelectOption } from '@workwave-tidal/core/components'
import { type RecurrenceWhen } from '../../../../types'
import { createRecurrenceWhenId } from './createRecurrenceWhenId'

export function createAnnuallyOptions(
  selectedDateYYYYMMDD: uui.domain.YYYYMMDD,
  formatRecurrenceWhenLabel: (recurrenceWhen: RecurrenceWhen) => string,
): SimpleSelectOption<string>[] {
  const selectedDate = dateUtils.parseDate(selectedDateYYYYMMDD)
  const cardinal = dateUtils.getWeekdayCardinality(selectedDate)

  const whenRecurrences: RecurrenceWhen[] = [
    {
      type: 'ANNUALLY',
      date: selectedDateYYYYMMDD,
    },
    {
      type: 'ANNUALLY',
      date: selectedDateYYYYMMDD,
      cardinal,
      month: getMonth(selectedDate) + 1, // getMonth returns 0-indexed month
      weekday: getDay(selectedDate),
    },
  ]

  // Create array of objects with day index as key and day name as value
  return whenRecurrences.map<SimpleSelectOption<string>>(recurrenceWhen => {
    return {
      value: createRecurrenceWhenId(recurrenceWhen),
      label: formatRecurrenceWhenLabel(recurrenceWhen),
    }
  })
}
